import React from 'react';
import { useTranslation } from 'react-i18next';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { useSubmitField } from '../../../hooks/useSubmitField';

interface Props {
  className?: string;
  noBottomSpacing?: boolean;
}

const FIELD_NAME = 'noai';

const NoAiCheckboxField: React.FC<Props> = ({ className, noBottomSpacing }) => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField(FIELD_NAME, {
    initAdapter: ({ deviation }) => deviation?.isAiUseDisallowed ?? true,
    submitAdapter: ({ noai }) => ({ noai }),
  });

  return (
    <BooleanInput
      className={className}
      name={FIELD_NAME}
      id={id}
      value={value}
      onChange={onChange}
      type="checkbox"
      size="large"
      label={t('deviationSubmit.form.labelOptions.noAI')}
      noBottomSpacing={noBottomSpacing}
    />
  );
};
NoAiCheckboxField.displayName = 'NoAiCheckboxField';

export default NoAiCheckboxField;
